import axios, { AxiosError, AxiosResponse } from "axios";
import { IEmailConfig } from "../interfaces/IEmailConfig";
import { store } from "../stores/store";
import { historys } from "../..";
import Swal, { SweetAlertResult } from "sweetalert2";
import { IMachine, IMachineConfig } from "../interfaces/IMachineConfig";


const sleep = (delay: number) => {
  return new Promise((resolve) => {
    setTimeout(resolve, delay);
  });
};
axios.defaults.withCredentials = true;
axios.defaults.baseURL = process.env.REACT_APP_API_URL;

axios.interceptors.response.use(
  async (response) => {
    await sleep(1000);
    const pagination = response.headers["pagination"];
    return response;
  },
  (error: AxiosError) => {
    const { data, status, config }: any = error.response!;
    switch (status) {
      case 400:
        // console.log("AxiosError JA",data);
        // Swal.fire({
        //   icon: "error",
        //   title: "Create User Error",
        //   text: data,
        //   showLoaderOnConfirm: true,
        // });
        if (typeof data === "string") {
          //toast.error(data);
          console.log("AxiosError JA", data);
          console.log(data);
        }
        if (config.method === "get" && data.errors.hasOwnProperty("id")) {
          historys.push("/not-found");
        }
        if (data.errors) {
          const modelStateErrors = [];
          console.log(data.errors);
          for (const key in data.errors) {
            console.log(key);
            if (data.errors[key]) {
              //  modelStateErrors.push(key)
              modelStateErrors.push(data.errors[key]);
            }
          }
          console.log(modelStateErrors);
          throw modelStateErrors.flat();
          //throw data.errors;
        }
        break;
      case 401:
        console.log("unauthorised");
        // toast.error("unauthorised");
        break;
      case 403:
        // history.push("/accessdenied");
        console.log("accessdenied");
        break;
      case 404:
        console.log("notfound");
        //history.push("/not-found");
        //toast.error('notfound');
        break;
      case 500:
        console.log("server error");
        //history.push("/server-error");
        // toast.error('server error');
        break;
    }
    return Promise.reject(error);
  }
);
const responseBody = <T>(response: AxiosResponse<T>) => response.data;

const requests = {
  get: <T>(url: string) => axios.get<T>(url).then(responseBody),
  post: <T>(url: string, body: any) =>
    axios.post<T>(url, body).then(responseBody),
  postFile: <T>(url: string, body: any) =>
    axios
      .post<T>(url, body, {
        headers: { "Content-Type": "multipart/form-data" },
      })
      .then(responseBody),
  download: <T>(url: string, body: any, filename: string) =>
    axios
      .post<T>(url, body, { responseType: "blob" })
      .then((response: AxiosResponse<any>) => {
      }),
    put: <T>(url: string, body: {}) => axios.put<T>(url, body).then(responseBody),
    delG: <T>(url: string, body: any) => axios.delete<T>(url, body).then(responseBody),
    del: <T>(url: string) => axios.delete<T>(url).then(responseBody),
  };
  

const EmailConfig = {
  SendEmailTypeChecking: (subject: IEmailConfig) =>
  axios.post<void>(`/Email/Send`, subject, {
    headers: { "content-type": "application/json" },
  }),
};
const MachineConfig = {
  getMachineBySerialNo: (input:IMachine) => requests.post<IMachineConfig>(`/Machine/GetMachineBySerial`,input),
  UpdateSerial: (data: IEmailConfig) =>
  axios.post<void>(`/Machine/UpdateSerial`, data, {
    headers: { "content-type": "application/json" },
  }),
};


export default {
  EmailConfig,
  MachineConfig
};
